import { Slider, SliderImages } from '@investoro/core';

export { type SliderImages };

export default Slider;
